module.exports = __webpack_public_path__ + "img/us.42219103.svg";